import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GetIntegrationsEffects } from './effects';
import { featureKey, reducer } from './reducer';
import { GetIntegrationsService } from './service';

@NgModule({
  imports: [EffectsModule.forFeature([GetIntegrationsEffects]), StoreModule.forFeature(featureKey, reducer)],
  providers: [GetIntegrationsService],
})
export class GetIntegrationsModule {}
